// src/components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMapMarkerAlt,
  faEnvelope,
  faPhone,
} from '@fortawesome/free-solid-svg-icons';
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons';

import './Footer.css';

export default function Footer() {
  /* helper: /diensten?service=slug  */
  const svc = slug => `/diensten?service=${slug}`;

  return (
    <footer className="site-footer pt-5 pb-4">
      <div className="container">
        {/* ───── drie kolommen ───── */}
        <div className="row gy-4">
          {/* kolom 1 */}
          <div className="col-12 col-md-4">
            <h4 className="footer-heading">OnlineGrowthClub.nl</h4>
            <ul className="footer-list">
              <li><Link to="/over-ons">Over ons</Link></li>
              <li><Link to="/diensten">Onze diensten</Link></li>
              <li><Link to="/portfolio">Portfolio</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/contact">Gratis groeiscan</Link></li>
            </ul>
          </div>

          {/* kolom 2 */}
          <div className="col-12 col-md-4">
            <h4 className="footer-heading">Diensten</h4>
            <ul className="footer-list">
              <li><Link to={svc('websites')}>Websites op maat</Link></li>
              <li><Link to={svc('seo')}>SEO</Link></li>
              <li><Link to={svc('social')}>Social-media beheer</Link></li>
              <li><Link to={svc('sea')}>SEA / Advertenties</Link></li>
              <li><Link to={svc('bundels')}>Bundel abonnementen</Link></li>
              <li><Link to={svc('influencers')}>Influencer marketing</Link></li>
            </ul>
          </div>

          {/* kolom 3 */}
          <div className="col-12 col-md-4">
            <h4 className="footer-heading">Contact</h4>
            <ul className="footer-contact">
              <li>
                <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
                Kersengaarde 230, 2272 NN Voorburg
              </li>
              <li>
                <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                <a href="mailto:contact@onlinegrowthclub.nl">
                  info@onlinegrowthclub.nl
                </a>
              </li>
              <li>
                <FontAwesomeIcon icon={faPhone} className="me-2" />
                <a href="tel:+31644109856">+31 6 – 44109856</a>
              </li>
              <li className="social-icons mt-2">
                <a href="https://www.instagram.com/onlinegrowthclub.nl" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <a href="https://www.instagram.com/onlinegrowthclub.nl" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a href="https://www.linkedin.com/company/onlinegrowthclub" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <FontAwesomeIcon icon={faLinkedinIn} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* onderbalk */}
        <div className="footer-bottom mt-4 pt-3 d-flex flex-column flex-md-row justify-content-between align-items-center">
          <span>© 2025 OnlineGrowthClub.nl</span>
          <div className="footer-legal-links">
            <Link to="/cookies">Cookies</Link>
            <Link to="/privacy">Privacybeleid</Link>
            <Link to="/terms">Gebruiksvoorwaarden</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
